import React from "react";
import TodoItem from "../TodoItem/TodoItem";
import styles from "./TodoList.module.css"

function TodoList({ tasks, toggleComplete, deleteTask }) {
  return (
    <table className="todo-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Task Name</th>
          <th>Description</th>
          <th>Deadline</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {tasks.map((task, index) => (
          <TodoItem
            key={index}
            index={index}
            task={task}
            toggleComplete={toggleComplete}
            deleteTask={deleteTask}
          />
        ))}
      </tbody>
    </table>
  );
}

export default TodoList;
